import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import { recordPage } from "@/assets/js/activity";
import Login from "@/components/Views/Login";
import Logout from "@/components/Views/Logout";
import Registration from "@/components/Views/Registration";
import RegistrationSuccess from "@/components/Views/RegistrationSuccess";
import ResetPassword from "@/components/Views/ResetPassword";
import CreateNewPassword from "@/components/Views/CreateNewPassword";
import Index from "@/components/Views/Index";
import NotFound from "@/components/Views/NotFound";

/*===== Document Views =====*/
import Documents from "@/components/Views/Documents/Index";

/*===== Admin Views =====*/
import AdminIndex from "@/components/Admin/Index";
import TestIndex from "@/components/Admin/Test";
import Machines from "@/components/Admin/Machines/Machines";
import MachineDetails from "@/components/Admin/Machines/MachineDetails";
import Assembly from "@/components/Admin/Assembly/Index";
import AssemblyDetails from "@/components/Admin/Assembly/AssemblyDetails";
import SubAssembly from "@/components/Admin/SubAssembly/Index";
import SubAssemblyDetails from "@/components/Admin/SubAssembly/AssemblyDetails";
import Parts from "@/components/Admin/Parts/Index";
import PartDetails from "@/components/Admin/Parts/PartDetails";
import Wear from "@/components/Admin/Wear/Index";
import WearDetails from "@/components/Admin/Wear/WearDetails";
import Companies from "@/components/Admin/Company/Index";
import CompanyDiscounts from "@/components/Admin/Company/CompanyDiscounts";
import CompanyDiscountDetails from "@/components/Admin/Company/CompanyDiscountDetails";
import ManageCompanies from "@/components/Admin/Company/Manage";
import ManageCompanyMachines from "@/components/Admin/Company/CompanyMachines";
import ManageCompanyMachineDetails from "@/components/Admin/Company/CompanyMachineDetails";
import EmailManagement from "@/components/Admin/EmailManagement/Index";
import EditEmailManagement from "@/components/Admin/EmailManagement/Edit";
import ContentBlock from "@/components/Admin/ContentBlocks/Index";
import EditContentBlock from "@/components/Admin/ContentBlocks/Edit";
import Pages from "@/components/Admin/Pages/Index";
import EditPageDetails from "@/components/Admin/Pages/Details";
import CompanySettings from "@/components/Admin/Settings/CompanySettings";
import Settings from "@/components/Admin/Settings/Index";
import Navigation from "@/components/Admin/Navigation/Index";
import EditNavigation from "@/components/Admin/Navigation/Edit";
import ListUsers from "@/components/Admin/Users/Index";
import UserDetails from "@/components/Admin/Users/Details";
import Sequence from "@/components/Admin/Sequence/Index";
import Import from "@/components/Admin/Import/Index";

/*===== Admin Error Views =====*/
import Errors from "@/components/Admin/Errors/Index";
import ErrorsDetails from "@/components/Admin/Errors/Details";

import Search from "@/components/Views/Search/Index";
import CustomerInsights from "@/components/Views/Reports/CustomerInsights";
import ManufacturingInsights from "@/components/Views/Reports/ManufacturingInsights/Index";
import FoundryInsights from "@/components/Views/Reports/FoundryInsights/Index";
import WorkOrderInsights from "@/components/Views/Reports/WorkOrderInsights/Index";
import ReportsDashboard from "@/components/Views/Reports/Reports_Dashboard";
import Contact from "@/components/Views/Contact/Index";
import About from "@/components/Views/Contact/About";

/*===== Account Views =====*/
import Dashboard from "@/components/Views/Account/Index";
import AccountInformation from "@/components/Views/Account/Information";
import OrderHistory from "@/components/Views/Account/OrderHistory";
import OrderDetails from "@/components/Views/Account/OrderDetails";
import RFQHistory from "@/components/Views/Account/RFQHistory";
import RFQDetails from "@/components/Views/Account/RFQDetails";
import SearchOrders from "@/components/Views/Account/Search";
import ReportBug from "@/components/Views/Account/ReportBug";
import SavedCarts from "@/components/Views/Account/SavedCarts";

/*===== Cart Views =====*/
import Cart from "@/components/Views/Cart/Index";
import FinalizeCart from "@/components/Views/Cart/Finalize";
import CartSuccess from "@/components/Views/Cart/Success";
import RFQSavedItems from "@/components/Views/Cart/RFQSavedItems";
import SavedRFQ from "@/components/Views/Cart/SavedRFQ";

/*===== Orders Views =====*/
import CreateOrder from "@/components/Views/Orders/Create";
import ChooseAssembly from "@/components/Views/Orders/ChooseAssembly";
import ShopAssembly from "@/components/Views/Orders/ShopAssembly";
import ShopWearParts from "@/components/Views/Orders/ShopWearParts";

/*===== RFQ Views =====*/
import RFQCreateOrder from "@/components/Views/RFQ/Create";
import RFQChooseAssembly from "@/components/Views/RFQ/ChooseAssembly";
import RFQShopAssembly from "@/components/Views/RFQ/ShopAssembly";
import RFQShopWearParts from "@/components/Views/RFQ/ShopWearParts";

/*===== Page Views =====*/
import PageView from "@/components/Views/Pages/Details";

/*===== Labs Views =====*/
import LabsIndex from "@/components/Views/Labs/Index";
import LabsMixes from "@/components/Views/Labs/Mixes";
import LabsMixDetail from "@/components/Views/Labs/MixDetail";
import LabsExtrusions from "@/components/Views/Labs/Extrusions";
import LabsExtrusionDetail from "@/components/Views/Labs/ExtrusionDetail";
import LabsSpecimens from "@/components/Views/Labs/Specimens";
import LabsRawMaterials from "@/components/Views/Labs/RawMaterials";

import auth from "@/store/auth";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        title: "Account Login | J.C. Steele & Sons SteeleService",
        breadcrumb: "Login",
      },
      props: { default: true, admin: false },
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout,
      meta: {
        breadcrumb: "Logout",
      },
    },
    {
      path: "/registration",
      name: "Registration",
      component: Registration,
      meta: {
        title: "Account Registration | J.C. Steele & Sons SteeleService",
        breadcrumb: "Registration",
      },
      props: { default: true, admin: false },
    },
    {
      path: "/registrationsuccess",
      name: "RegistrationSuccess",
      component: RegistrationSuccess,
      meta: {
        title: "Account Registration Success | J.C. Steele & Sons SteeleService",
        breadcrumb: "Registration Success",
      },
      props: { default: true, admin: false },
    },
    {
      path: "/resetpassword",
      name: "ResetPassword",
      component: ResetPassword,
      meta: {
        title: "Password Reset | J.C. Steele & Sons SteeleService",
        breadcrumb: "Reset Password",
      },
      props: { default: true, admin: false },
    },
    {
      path: "/createnewpassword",
      name: "CreateNewPassword",
      component: CreateNewPassword,
      meta: {
        title: "Create New Password | J.C. Steele & Sons SteeleService",
        breadcrumb: "Create New Password",
      },
      props: { default: true, admin: false },
    },
    {
      path: "/",
      name: "Index",
      component: Index,
      meta: {
        title: "Home | J.C. Steele & Sons SteeleService",
        breadcrumb: "Home",
      },
      props: { default: true, admin: false },
    },

    /* ===== Admin ===== */
    {
      path: "/admin/index",
      name: "Admin Index",
      component: AdminIndex,
      meta: {
        title: "Admin Dashboard | J.C. Steele & Sons SteeleService",
        breadcrumb: "Admin Dashboard",
      },
      props: { default: true, admin: true },
      alias: "/admin",
      beforeEnter: requireAdminAuth,
    },
    {
      /* Customer Insights report (Phase 1). Uses the REGULAR (customer) site
         shell — admin:false — not the admin sidebar layout. Any signed-in user
         can reach the route; the role-gated nav button controls who SEES it and
         the backend ([Authorize] Master/Sales roles) controls the data, so a
         Customer who hand-types the URL just gets an empty frame, no leak. */
      path: "/reports/customer-insights",
      name: "Customer Insights",
      component: CustomerInsights,
      meta: {
        title: "Customer Insights | J.C. Steele & Sons SteeleService",
        breadcrumb: "Customer Insights",
      },
      props: { default: true, admin: false },
      alias: "/reports",
      beforeEnter: requireAuth,
    },
    {
      /* Foundry Insights — a self-contained foundry report over /api/foundry-insights/*.
         Same customer shell as Customer Insights (admin:false). Any signed-in user can reach
         the route; the report-access card + the backend [Authorize(Foundry)] control who sees
         data, and the component shows a friendly "no access" panel otherwise. */
      path: "/reports/foundry-insights",
      name: "Foundry Insights Report",
      component: FoundryInsights,
      meta: {
        title: "Foundry Insights | J.C. Steele & Sons SteeleService",
        breadcrumb: "Foundry Insights",
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      /* Manufacturing Insights — a self-contained report (Machine Shop / Shipping / Parts
         Sales / Foundry / Forecasting) over the /api/manufacturing-insights/* endpoints.
         Same customer shell as Customer Insights (admin:false). Any signed-in user can reach
         the route; the report-access card + the backend [Authorize(Manufacturing)] control who
         sees data, and the component shows a friendly "no access" panel otherwise. */
      path: "/reports/manufacturing-insights",
      name: "Manufacturing Insights Report",
      component: ManufacturingInsights,
      meta: {
        title: "Manufacturing Insights | J.C. Steele & Sons SteeleService",
        breadcrumb: "Manufacturing Insights",
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      /* Work Order Insights — a self-contained report (Throughput / Aging / Cost & Variance /
         Work-Center & Material / Dependencies) over the /api/work-order-insights/* endpoints.
         Same customer shell as the other reports (admin:false). Any signed-in user can reach the
         route; the report-access card + the backend [Authorize(Manufacturing)] control who sees
         data (WOI reuses the Manufacturing role), and the component shows a "no access" panel otherwise. */
      path: "/reports/work-order-insights",
      name: "Work Order Insights Report",
      component: WorkOrderInsights,
      meta: {
        title: "Work Order Insights | J.C. Steele & Sons SteeleService",
        breadcrumb: "Work Order Insights",
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      /* Reports dashboard — a landing page of cards for the reports a user has access to
         (Report Access / rpt_UserReportAccess; a Master sees all). Each card deep-links into
         the Sales Insights page with ?report=<key>. Regular customer site shell (admin:false);
         any signed-in user may load it — the visible cards + the report's server-side
         [Authorize]/scoping enforce access. An admin points a nav button at /reports/reports-dashboard. */
      path: "/reports/reports-dashboard",
      name: "Reports Dashboard",
      component: ReportsDashboard,
      meta: {
        title: "Reports | J.C. Steele & Sons SteeleService",
        breadcrumb: "Reports",
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/admin/errors/index",
      name: "Errors",
      component: Errors,
      meta: {
        title: "Error Log | J.C. Steele & Sons SteeleService",
        breadcrumb: "Errors",
      },
      props: { default: true, admin: true },
      alias: "/admin/errors",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/errors/details/:id",
      name: "ErrorsDetails",
      component: ErrorsDetails,
      meta: {
        title: "Error Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Error Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/test",
      name: "Test",
      component: TestIndex,
      meta: {
        breadcrumb: "Test",
      },
      props: { default: true, admin: true },
      alias: "/test",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/machines/machines",
      name: "Machines",
      component: Machines,
      meta: {
        title: "Machines | J.C. Steele & Sons SteeleService",
        breadcrumb: "Machines",
      },
      props: { default: true, admin: true },
      alias: "/admin/machines",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/machines/machinedetails/:id",
      name: "EditMachine",
      component: MachineDetails,
      meta: {
        title: "Machine Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Machine Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/assembly/index",
      name: "Assembly",
      component: Assembly,
      meta: {
        title: "Assemblies | J.C. Steele & Sons SteeleService",
        breadcrumb: "Assemblies",
      },
      props: { default: true, admin: true },
      alias: "/admin/assembly",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/assembly/assemblydetails/:id",
      name: "EditAssembly",
      component: AssemblyDetails,
      meta: {
        title: "Assembly Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Assembly Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/subassembly/index",
      name: "SubAssembly",
      component: SubAssembly,
      meta: {
        title: "Sub Assemblies | J.C. Steele & Sons SteeleService",
        breadcrumb: "Sub Assemblies",
      },
      props: { default: true, admin: true },
      alias: "/admin/subassembly",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/subassembly/assemblydetails/:id",
      name: "EditSubAssembly",
      component: SubAssemblyDetails,
      meta: {
        title: "Sub Assembly Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Sub Assembly Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/parts/index",
      name: "Parts",
      component: Parts,
      meta: {
        title: "Parts | J.C. Steele & Sons SteeleService",
        breadcrumb: "Parts",
      },
      props: { default: true, admin: true },
      alias: "/admin/parts",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/parts/partdetails/:id",
      name: "EditParts",
      component: PartDetails,
      meta: {
        title: "Part Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Part Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/wear/index",
      name: "Wear",
      component: Wear,
      meta: {
        title: "Wear Parts | J.C. Steele & Sons SteeleService",
        breadcrumb: "Wear Parts",
      },
      props: { default: true, admin: true },
      alias: "/admin/wear",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/wear/weardetails/:id",
      name: "Wear Details",
      component: WearDetails,
      meta: {
        title: "Wear Part Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Wear Part Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/sequence/index",
      name: "Sequence",
      component: Sequence,
      meta: {
        title: "Sequence | J.C. Steele & Sons SteeleService",
        breadcrumb: "Sequence",
      },
      props: { default: true, admin: true },
      alias: "/admin/sequence",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/company/index",
      name: "Companies",
      component: Companies,
      meta: {
        title: "Companies | J.C. Steele & Sons SteeleService",
        breadcrumb: "Companies",
      },
      props: { default: true, admin: true },
      alias: "/admin/company",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/company/manage/:id",
      name: "ManageCompanies",
      component: ManageCompanies,
      meta: {
        title: "Company Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Company Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/company/machines",
      name: "Manage Company Machines",
      component: ManageCompanyMachines,
      meta: {
        title: "Company Machines | J.C. Steele & Sons SteeleService",
        breadcrumb: "Company Machines",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/company/machinedetails/:id",
      name: "Manage Company Machine Details",
      component: ManageCompanyMachineDetails,
      meta: {
        title: "Company Machine Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Company Machine Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/company/discounts",
      name: "Manage Company Discounts",
      component: CompanyDiscounts,
      meta: {
        title: "Company Discounts | J.C. Steele & Sons SteeleService",
        breadcrumb: "Company Discounts",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/company/discounts/:id",
      name: "Manage Company Discount Details",
      component: CompanyDiscountDetails,
      meta: {
        title: "Company Discount Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Company Discount Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/emailmanagement/index",
      name: "Manage Email Messages",
      component: EmailManagement,
      meta: {
        title: "Email Management | J.C. Steele & Sons SteeleService",
        breadcrumb: "Email Management",
      },
      props: { default: true, admin: true },
      alias: "/admin/emailmanagement",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/emailmanagement/edit/:id",
      name: "Edit Email Messages",
      component: EditEmailManagement,
      meta: {
        title: "Edit Email | J.C. Steele & Sons SteeleService",
        breadcrumb: "Edit Email",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/ContentBlocks/Index",
      name: "Content Block",
      component: ContentBlock,
      meta: {
        title: "Content Blocks | J.C. Steele & Sons SteeleService",
        breadcrumb: "Content Blocks",
      },
      props: { default: true, admin: true },
      alias: "/admin/ContentBlocks",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/ContentBlocks/Edit/:id",
      name: "Edit Content Block",
      component: EditContentBlock,
      meta: {
        title: "Edit Content Block | J.C. Steele & Sons SteeleService",
        breadcrumb: "Edit Content Block",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/Pages/Index",
      name: "Pages",
      component: Pages,
      meta: {
        title: "Pages | J.C. Steele & Sons SteeleService",
        breadcrumb: "Pages",
      },
      props: { default: true, admin: true },
      alias: "/admin/pages",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/Pages/Edit/:id",
      name: "Edit Page Details",
      component: EditPageDetails,
      meta: {
        title: "Page Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Page Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/settings/companysettings",
      name: "Company Settings",
      component: CompanySettings,
      meta: {
        title: "Company Settings | J.C. Steele & Sons SteeleService",
        breadcrumb: "Company Settings",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/settings/index",
      name: "Settings",
      component: Settings,
      meta: {
        title: "Global Settings | J.C. Steele & Sons SteeleService",
        breadcrumb: "Global Settings",
      },
      props: { default: true, admin: true },
      alias: "/admin/settings",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/import/index",
      name: "Import",
      component: Import,
      meta: {
        title: "Import | J.C. Steele & Sons SteeleService",
        breadcrumb: "Import",
      },
      props: { default: true, admin: true },
      alias: "/admin/import",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/navigation/index",
      name: "Navigation",
      component: Navigation,
      meta: {
        title: "Navigation | J.C. Steele & Sons SteeleService",
        breadcrumb: "Navigation",
      },
      props: { default: true, admin: true },
      alias: "/admin/navigation",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/navigation/edit/:id",
      name: "Edit Navigation",
      component: EditNavigation,
      meta: {
        title: "Edit Navigation | J.C. Steele & Sons SteeleService",
        breadcrumb: "Edit Navigation",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/users/index",
      name: "List Users",
      component: ListUsers,
      meta: {
        title: "Users | J.C. Steele & Sons SteeleService",
        breadcrumb: "Users",
      },
      props: { default: true, admin: true },
      alias: "/admin/users",
      beforeEnter: requireAdminAuth,
    },
    {
      path: "/admin/users/details/:id",
      name: "UserDetails",
      component: UserDetails,
      meta: {
        title: "User Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "User Details",
      },
      props: { default: true, admin: true },
      beforeEnter: requireAdminAuth,
    },

    /* ===== Account ===== */
    {
      path: "/account/index",
      name: "Account Dashboard",
      alias: "/account",
      component: Dashboard,
      meta: {
        title: "Account Dashboard | J.C. Steele & Sons SteeleService",
        breadcrumb: "Account",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Account", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/account/information",
      name: "Account Information",
      component: AccountInformation,
      meta: {
        title: "Account Information | J.C. Steele & Sons SteeleService",
        breadcrumb: "Account Information",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Account", path: "/account" },
          { label: "Account Information", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    // The standalone "Order History" route was removed.
    // Its old definition had a malformed path
    // (path: "/account/savedcarts?tab=orders") which Vue
    // Router treated as a literal URL pattern and never
    // matched anything, so all links to /account/orderhistory
    // 404'd. Order history is now consolidated into the
    // SavedCarts page on the Orders tab.
    //
    // The redirect target MUST be the object form
    // ({ path, query }) — not a string with "?tab=orders"
    // appended, because Vue Router 3 treats the embedded
    // "?" as a literal character in the path and the
    // resulting URL doesn't match any route. Object form
    // tells the router "navigate to path X with query Y"
    // explicitly.
    {
      path: "/account/orderhistory",
      redirect: { path: "/account/savedcarts", query: { tab: "orders" } },
    },
    {
      path: "/account/orderdetails/:id",
      name: "Order Details",
      component: OrderDetails,
      meta: {
        title: "Account - Order Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Order Details",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Account", path: "/account" },
          { label: "Order History", path: "/account/savedcarts?tab=orders" },
          { label: "Order Details", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    // Standalone "RFQ History" route removed for the same
    // reason as Order History above. See that comment for
    // the object-form rationale.
    {
      path: "/account/rfqhistory",
      redirect: { path: "/account/savedcarts", query: { tab: "quotes" } },
    },
    {
      path: "/account/rfqdetails/:id",
      name: "RFQ Details",
      component: RFQDetails,
      meta: {
        title: "Account - Quote Details | J.C. Steele & Sons SteeleService",
        breadcrumb: "Quote Details",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Account", path: "/account" },
          { label: "Quote History", path: "/account/savedcarts?tab=quotes" },
          { label: "Quote Details", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/account/search",
      name: "SearchOrders",
      component: SearchOrders,
      meta: {
        title: "Search Orders | J.C. Steele & Sons SteeleService",
        breadcrumb: "Search Orders",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Account", path: "/account" },
          { label: "Search Orders", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/account/savedcarts",
      name: "Saved Carts",
      component: SavedCarts,
      meta: {
        title: "Saved Carts | J.C. Steele & Sons SteeleService",
        breadcrumb: "Saved Carts",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Account", path: "/account" },
          { label: "Saved Carts", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },

    /* ===== Orders ===== */
    {
      path: "/orders/create",
      name: "Create New Order",
      component: CreateOrder,
      meta: {
        title: "Create New Order | J.C. Steele & Sons SteeleService",
        breadcrumb: "Create New Order",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Order", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/orders/chooseassembly",
      name: "Create Order - Choose Assembly",
      component: ChooseAssembly,
      meta: {
        title: "Create New Order - Choose Assembly | J.C. Steele & Sons SteeleService",
        breadcrumb: "Choose Assembly",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Order", path: "/orders/create" },
          { label: "Choose Assembly", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/orders/shopwearparts",
      name: "Create Order - Shop Wear Parts",
      component: ShopWearParts,
      meta: {
        title: "Create New Order - Shop Wear Parts | J.C. Steele & Sons SteeleService",
        breadcrumb: "Shop Wear Parts",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Order", path: "/orders/create" },
          { label: "Shop Wear Parts", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/orders/shopassembly",
      name: "Create Order - Shop Assembly",
      component: ShopAssembly,
      meta: {
        title: "Create New Order - Shop Assembly | J.C. Steele & Sons SteeleService",
        breadcrumb: "Shop Assembly",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Order", path: "/orders/create" },
          { label: "Shop Assembly", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },

    /* ===== RFQ ===== */
    {
      path: "/RFQ/create",
      name: "Create New Quote",
      component: RFQCreateOrder,
      meta: {
        title: "Create New Quote | J.C. Steele & Sons SteeleService",
        breadcrumb: "Create New Quote",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Quote", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/rfq/shopwearparts",
      name: "Create Quote - Shop Wear Parts",
      component: RFQShopWearParts,
      meta: {
        title: "Create New Quote - Shop Wear Parts | J.C. Steele & Sons SteeleService",
        breadcrumb: "Shop Wear Parts",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Quote", path: "/RFQ/create" },
          { label: "Shop Wear Parts", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/RFQ/chooseassembly",
      name: "Create Quote - Choose Assembly",
      component: RFQChooseAssembly,
      meta: {
        title: "Create New Quote - Choose Assembly | J.C. Steele & Sons SteeleService",
        breadcrumb: "Choose Assembly",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Quote", path: "/RFQ/create" },
          { label: "Choose Assembly", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/RFQ/shopassembly",
      name: "Create Quote - Shop Assembly",
      component: RFQShopAssembly,
      meta: {
        title: "Create New Quote - Shop Assembly | J.C. Steele & Sons SteeleService",
        breadcrumb: "Shop Assembly",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Quote", path: "/RFQ/create" },
          { label: "Shop Assembly", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },

    /* ===== Cart ===== */
    {
      path: "/cart/rfqsaveditems",
      name: "Quote Saved Items",
      component: RFQSavedItems,
      meta: {
        title: "Quote Cart | J.C. Steele & Sons SteeleService",
        breadcrumb: "Review Quote",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Quote", path: "/RFQ/create" },
          { label: "Review Quote", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/cart/savedrfq",
      name: "Saved Quote",
      component: SavedRFQ,
      meta: {
        title: "Saved Quotes | J.C. Steele & Sons SteeleService",
        breadcrumb: "Saved Quote",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Saved Quote", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/cart/index",
      name: "Cart",
      alias: "/cart",
      component: Cart,
      meta: {
        title: "Cart | J.C. Steele & Sons SteeleService",
        breadcrumb: "Review & Checkout",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Order", path: "/orders/create" },
          { label: "Review & Checkout", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/cart/finalize",
      name: "Finalize Cart",
      component: FinalizeCart,
      meta: {
        title: "Finalize Order | J.C. Steele & Sons SteeleService",
        breadcrumb: "Finalize Order",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Order", path: "/orders/create" },
          { label: "Finalize Order", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/cart/success",
      name: "Cart Success",
      component: CartSuccess,
      meta: {
        title: "Order Success | J.C. Steele & Sons SteeleService",
        breadcrumb: "Order Success",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Create New Order", path: "/orders/create" },
          { label: "Order Success", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },

    /* ===== Search / Documents / Misc ===== */
    {
      path: "/search/index",
      name: "Search",
      alias: "/search",
      component: Search,
      meta: {
        title: "Search | J.C. Steele & Sons SteeleService",
        breadcrumb: "Search Results",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Search Results", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/documents",
      name: "Documents",
      component: Documents,
      meta: {
        title: "Documents | J.C. Steele & Sons SteeleService",
        breadcrumb: "Documents",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Documents", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/contact/index",
      name: "Contact",
      alias: "/contact",
      component: Contact,
      meta: {
        title: "Contact Us | J.C. Steele & Sons SteeleService",
        breadcrumb: "Contact",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Contact", path: null },
        ],
      },
      props: { default: true, admin: false },
    },
    {
      path: "/contact/about",
      name: "About",
      component: About,
      meta: {
        title: "About Us | J.C. Steele & Sons SteeleService",
        breadcrumb: "About",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "About", path: null },
        ],
      },
      props: { default: true, admin: false },
    },
    {
      path: "/report-bug",
      name: "ReportBug",
      alias: "/report",
      component: ReportBug,
      meta: {
        title: "Report Bug | J.C. Steele & Sons SteeleService",
        breadcrumb: "Report Bug",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Report Bug", path: null },
        ],
      },
      props: { default: true, admin: false },
    },
    {
      path: "/Pages/Details/:name",
      name: "PagesDetails",
      alias: "/Pages/:name",
      component: PageView,
      meta: {
        title: "Page | J.C. Steele & Sons SteeleService",
        breadcrumb: "Page",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Page", path: null },
        ],
      },
      props: { default: true, admin: false },
    },

    /* ===== Labs ===== */
    {
      path: "/labs",
      name: "Labs",
      component: LabsIndex,
      meta: {
        title: "Labs | J.C. Steele & Sons SteeleService",
        breadcrumb: "Labs",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Labs", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/labs/mixes",
      name: "LabsMixes",
      component: LabsMixes,
      meta: {
        title: "Labs - Mixes | J.C. Steele & Sons SteeleService",
        breadcrumb: "Mixes",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Labs", path: "/labs" },
          { label: "Mixes", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/labs/mixes/:id",
      name: "LabsMixDetail",
      component: LabsMixDetail,
      meta: {
        title: "Labs - Mix Detail | J.C. Steele & Sons SteeleService",
        breadcrumb: "Mix Detail",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Labs", path: "/labs" },
          { label: "Mixes", path: "/labs/mixes" },
          { label: "Mix Detail", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/labs/extrusions",
      name: "LabsExtrusions",
      component: LabsExtrusions,
      meta: {
        title: "Labs - Extrusions | J.C. Steele & Sons SteeleService",
        breadcrumb: "Extrusions",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Labs", path: "/labs" },
          { label: "Extrusions", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/labs/extrusions/:id",
      name: "LabsExtrusionDetail",
      component: LabsExtrusionDetail,
      meta: {
        title: "Labs - Extrusion Detail | J.C. Steele & Sons SteeleService",
        breadcrumb: "Extrusion Detail",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Labs", path: "/labs" },
          { label: "Extrusions", path: "/labs/extrusions" },
          { label: "Extrusion Detail", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/labs/specimens",
      name: "LabsSpecimens",
      component: LabsSpecimens,
      meta: {
        title: "Labs - Specimens | J.C. Steele & Sons SteeleService",
        breadcrumb: "Specimens",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Labs", path: "/labs" },
          { label: "Specimens", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },
    {
      path: "/labs/raw-materials",
      name: "LabsRawMaterials",
      component: LabsRawMaterials,
      meta: {
        title: "Labs - Raw Materials | J.C. Steele & Sons SteeleService",
        breadcrumb: "Raw Materials",
        breadcrumbs: [
          { label: "Home", path: "/account" },
          { label: "Labs", path: "/labs" },
          { label: "Raw Materials", path: null },
        ],
      },
      props: { default: true, admin: false },
      beforeEnter: requireAuth,
    },

    {
      path: "*",
      name: "Page Not Found",
      component: NotFound,
      meta: {
        title: "404 | J.C. Steele & Sons SteeleService",
        breadcrumb: "Page Not Found",
      },
      props: { default: true, admin: false },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

function requireAdminAuth(to, from, next) {
  if (auth.state.user != null) {
    let isAdmin = auth.state.user.admin;

    if (isAdmin) {
      next();
    } else {
      next("/");
    }
  } else {
    // Preserve the intended destination so login can return the user to it
    // (deep links like the report-chart email's /admin/replace-chart URL).
    // Login.vue's checkCurrentLogin already honors ?redirect=.
    next({ path: "/login", query: { redirect: to.fullPath } });
  }
}

function requireAuth(to, from, next) {
  if (auth.state.user != null) {
    next();
  } else {
    next({ path: "/login", query: { redirect: to.fullPath } });
  }
}

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  if (!nearestWithMeta) {
    return next();
  }

  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      tag.setAttribute("data-vue-router-controlled", "");
      return tag;
    })
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

router.afterEach((to) => {
  NProgress.done();
  $(".ui.dropdown").dropdown({ fullTextSearch: true });
  // Activity trail: one row per navigation. Stashing the route name on window lets the
  // click/search recorders label their events without importing the router (which would
  // close an import cycle back through this file).
  try { window.__jcsRouteName = to && to.name; } catch (e) { /* ignore */ }
  recordPage(to);
});

export default router;